// extracted by mini-css-extract-plugin
export default {"container":"_videos_container__0C8NU","card":"_videos_card__dbzOE"};